<template>
  <div>
    <DialogBottomSheet
      :is-visible="isDialogOpened"
      :width="isMobile ? undefined : 375"
      content-class="rounded-0"
      @input="filtersStore.resetUnsavedFilters"
      @dialog-bottom-sheet:change-visible="closeDialog"
    >
      <v-card
        tile
        class="pt-6 px-4 pb-4"
      >
        <ChipGroupScience
          v-model="filtersStore.unsavedFilters"
          class="mb-2"
        >
          <template #title>
            <div class="text-h6 mb-2">
              {{ t('Минимальная ученая степень', options) }}
            </div>
          </template>
        </ChipGroupScience>
        <BtnShowDoctors
          :active="isDialogOpened"
          @click:close="closeDialog"
          @click:submit="applyFilter"
        />
      </v-card>
    </DialogBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { dispatchCustomEventGlobally } from 'www/utils'
import I18NextVue from 'i18next'
import DialogBottomSheet from 'www/vue_components/common/core/DialogBottomSheet.vue'
import useChipsStore from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import updateDoctorListPage from 'www/vue_components/common/TheFilters/doctors/functions/updateDoctorListPage'
import BtnShowDoctors from 'www/vue_components/common/TheFilters/doctors/components/BtnShowDoctors/BtnShowDoctors.vue'
import ChipGroupScience from 'www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/ChipGroupScience/ChipGroupScience.vue'
import { EVENTS as SNACKBAR_EVENTS } from 'www/vue_components/common/core/SnackbarNotification/constants'

const chipsStore = useChipsStore()
const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ScienceFilters')
const isMobile = window.MOBILE_VERSION

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

watch(
  () => filtersStore.filters.science,
  () => {
    if (!filtersStore.filters.science) {
      chipsStore.updateScienceChip({ isVisible: false })
      return
    }

    const name = ({
      1: t('Кандидат наук', options.value),
      2: t('Доктор наук', options.value),
      3: t('Профессор', options.value),
    })[filtersStore.filters.science]

    chipsStore.updateScienceChip({
      name,
      isActive: true,
      isVisible: true,
      onClick: openDialog,
      async onReset() {
        filtersStore.updateFilters({ science: undefined })

        await updateDoctorListPage()

        dispatchCustomEventGlobally(SNACKBAR_EVENTS.open, {
          upper: true,
          message: t('Фильтр сброшен', options.value),
        })
      },
    })
  },
  { immediate: true },
)

const applyFilter = async () => {
  closeDialog()
  filtersStore.applyUnsavedFilters()
  await updateDoctorListPage()
}
</script>
